module.exports = __webpack_public_path__ + "static/img/ry_czjt.d2b47bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ry_czjt.jpg
// module id = /h03
// module chunks = 2